"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataTransferSchema = void 0;
const schemaComponents_1 = require("@/schemaComponents");
const getDataTransferSchema = ({ langIds, }) => {
    return (0, schemaComponents_1.mergeSchema)({ schemaType: "object", properties: [] }, [
        {
            title: "テキストID",
            propertyName: "scriptId",
            schema: {
                schemaType: "text",
                required: true,
            },
        },
        {
            title: "テキスト",
            propertyName: "text",
            schema: {
                schemaType: "text",
            },
        },
        ...(langIds
            ? langIds.map((langId) => ({
                title: "翻訳文",
                propertyName: `translations.${langId}`,
                schema: {
                    schemaType: "text",
                },
            }))
            : []),
    ]);
};
exports.getDataTransferSchema = getDataTransferSchema;
